// eslint-disable-next-line import/no-anonymous-default-export
export default {
  translation: {
    keys: {
      hi: 'Hi',
      all: 'All',
      logout: 'Logout',
      signin: 'Sign In',
      continue: 'Continue',
      recovery_password: 'Recovery my password',
      back: 'Back',
      created_at: 'Created at',
      updated_at: 'Updated at',
      no_entries: 'No entries found',
      filter: 'Filter',
      filters: 'Filters',
      data: 'Data',
      columns: 'Columns',
      saving: 'Saving...',
      loading: 'Loading...',
      waiting: 'Waiting...',
      downloading: 'Downloading...',
      today: 'today',
      month: 'month',
      week: 'week',
      day: 'day',
      list: 'list',
      previous: 'previous',
      next: 'next',
      details: 'Details',
      warnings: 'Warnings',
      description: 'Description',
      unknown: 'Unknown',
      free_price: 'Free',
      paid_price: 'Paid',
      rerun: 'Rerun',
    },

    layout: {
      nav: {
        bots: { title: 'My Bots' },
        marketplace: { title: 'Marketplace' },
        reports: { title: 'Reports' },
        databases: { title: 'Databases' },
        ocr: { title: 'OCR' },
        templates: { title: 'Templates' },
        admin: { title: 'Admin' },
        help: { title: 'Help' },
      },
    },

    columns: {
      clean_all: 'Clean all data',
      name: 'Name',
      agenda_id: 'Group ID',
      email: 'Email',
      confirmation_code: 'Confirmation Code',
      lang: 'Language',
      password: 'Password',
      attempts: 'Attempts',
      created_at: 'Created at',
      created_by: 'Created by',
      updated_at: 'Updated at',
      status: 'Status',
      started_at: 'Started at',
      start_at: 'Start at',
      title: 'Title',
      failed_reason: 'Failed Reason',
      done_at: 'Done at',
      reason: 'Reason',
      type: 'Type',
      description: 'Description',
      template: 'Template',
      device: 'Device',
    },

    messages: {
      invalid_password: 'Invalid current password. Try again',
      invalid_user_password: 'Invalid user or password.',
      invalid_user: 'Invalid user. Try again',
      invalid_code: 'Invalid confirmation code. Try again',
      unexpected_error: 'Unexpected error. Try again.',
    },

    dialogs: {
      default: {
        title: 'Warning!',
        description: 'Are you sure about that?',
      },
      buttons: {
        cancel: 'No, cancel',
        confirm: 'Yes, continue',
      },
      remove: {
        title: 'Warning!',
        description: 'Do you really want to remove this?',
      },
    },

    formats: {
      date: 'YYYY/MM/DD',
      datetime: 'YYYY/MM/DD HH:mm',
    },

    actions: {
      save: 'Save',
      saving: 'Saving',
      run: 'Run job',
      stop: 'Stop',
      cancel: 'Cancel',
      remove: 'Remove',
      make_admin: 'Make Admin',
      remove_admin: 'Remove Admin',
      remove_entry: 'Remove entry',
      remove_entry_group: 'Remove all group entries ',
      delete: 'Remove',
      search: 'Search',
      import: 'Import',
      add: 'Add',
      create: 'Create',
      edit: 'Edit',
      invite: 'Invite',
      resend: 'Resend',
      change: 'Change',
      change_password: 'Change password',
      remove_all: 'Remove all',
      add_rule: 'Add rule',
      export_csv: 'Export to CSV',
      hire: 'Hire',
      requesting: 'Requesting',
    },

    status: {
      pending: 'Pending',
      working: 'Working',
      failed: 'Failed',
      canceled: 'Canceled',
      done: 'Done',
      not_done: 'Not Done',
      processing: 'Processing',
      open: 'Open',
      in_progress: 'In progress',
    },

    authorizer: {
      no_permission: "You don't have permission to see this page.",
    },

    signin: {
      description: 'Sign in with your credentials.',
      code_sent: 'We sent a confirmation code to your email.',

      form: {
        email_input: {
          placeholder: 'Type your email',
        },
        password_input: {
          placeholder: 'Type your password',
        },
        code_input: {
          placeholder: 'Type your confirmation code',
        },
      },
    },

    forget_password: {
      title: 'Forget your password?',
      description: 'Get your account back! Enter your e-mail and we will send you a link so that you can recover your password.',
    },

    profile: {
      title: 'Profile',
      dialogs: {
        remove_avatar: {
          description: 'Do you really want to remove your avatar?',
        },
      },

      messages: {
        success_avatar_removed: 'Avatar removed!',
        success_avatar_changed: 'Avatar saved!',
      },

      about_form: {
        title: 'About me',
        name_input: {
          label: 'Name:',
          placeholder: 'Type your name',
        },
        email_input: {
          label: 'Email:',
          placeholder: 'Type your email',
        },
        lang_input: {
          label: 'Language:',
          placeholder: 'Select your language',
        },
      },

      security_form: {
        title: 'Security',
        password_input: {
          label: 'Current password:',
          placeholder: 'Type your current password',
        },
        new_password_input: {
          label: 'New password:',
          placeholder: 'Type your new password',
        },
      },
    },

    explore: {
      title: 'Marketplace',
      categories: {
        title: 'Categories',
      },
      actions: {
        request_custom: 'Request custom bot',
      },
      add: {
        title: 'Bot Hire',
        free: 'This robot is free and requires no application to be hired.',
        paid: 'This robot requires a request to be hired. If you are interested, please contact us through the button below:',
        button_add_free: 'Hire',
        button_add_free_hired: 'Hired!',
        button_add_paid: 'Request',
        button_add_paid_hired: 'Requested!',
      },
      price: {
        free: 'Free',
        paid: 'Available upon request',
      },
      install: {
        title: 'How to install and run?',
        text: '<p>To install our robots you need to install the Youfy Agent application on your computer. Download the app using one of the links below according to the operating system of the computer where you want to install it and follow the installer step by step.</p><p>After installation, open the application and login using your credentials. All contracted robots will be displayed. Download the desired robots by clicking the download button and then activate it by clicking the activate button.</p><p>Ready! After activation the robot is ready to receive jobs through our web application. On "My Bots" page, select the robot you want and click run.</p>',
      },
    },

    bots: {
      title: 'My Bots',
      bots_found: 'robots available',
      no_entries: 'Your company does not have any bot yet.',
      no_config: 'Settings is not available for this bot',
      tabs: {
        jobs: 'Jobs',
        calendar: 'Calendar',
        config: 'Settings',
        reports: 'Reports',
      },
      categories: {
        title: 'Departments',
        none: 'No department',
      },
      config: {
        about: {
          title: 'DATA',
        },
        notification: {
          title: 'NOTIFICATIONS',
          form: {
            events: 'Events',
          },
        },
        task: {
          title: 'TASK',
          no_form_message: 'This bot does not require any settings.',
        },
      },
      reports: {
        add: {
          title: 'New report',
          form: {
            name: {
              label: 'Report Name',
            },
            description: {
              label: 'Description',
            },
          },
        },
      },
      jobs: {
        disabled: 'This bot is disabled',
        details: {
          title: "Job's details",
        },
        messages: {
          waiting_device: 'Waiting device response...',
        },
        add: {
          title: 'Run job',
          no_form_message: 'This bot does not require any params.',
          error_add: 'Fail to create job. Please, try again.',
        },
        card: {
          pending: 'In queue',
          done: 'Done',
          bot_done: 'Not done',
          failed: 'Failed',
          total: 'Total',
          working: 'Working',
          avg_time: 'Average time',
          job_time: 'Total time',
          columns: {
            request_by: 'Requested by',
            created_at: 'Requested at',
            started_at: 'Started at',
            done_at: 'Done at',
          },
        },
        sections: {
          working: {
            title: 'WORKING',
          },
          last_jobs: {
            title: 'LAST JOBS',
          },
        },
      },
    },

    bot_report: {},

    agenda: {
      actions: {
        repeat: 'Repeat',
      },
      dialogs: {
        remove_item: {
          title: 'Remove item',
          description: `Do you really want to remove <b>{{title}}</b> at {{ date }}?`,
        },

        remove_all: {
          title: 'Remove all items',
          description: `Do you really want to remove <b class="text-danger">all</b> items?`,
        },
      },

      form: {
        title: {
          label: 'Identification title',
        },
        date: {
          label: 'Date',
        },
        time: {
          label: 'Time',
        },
      },
    },

    devices: {
      form: {
        title: {
          label: 'Device',
        },
      },
    },

    work_objects: {
      title: 'Work objects',
    },

    databases: {
      title: 'Databases',
    },

    ocr: {
      title: 'OCR',
      add: {
        title: 'Add OCR Template',
      },
    },

    templates: {
      title: 'Templates',
      helps: {
        name: 'Name is unique id without special characters to identify template.',
      },
    },

    reports: {
      title: 'Reports',
      require_filter: 'Please, fill the report filters to view the data.',
    },

    database: {
      not_found: "Oops! I couldn't find the database you're looking for.",
      actions: {
        import_data: 'Import datasets',
      },
      alerts: {
        remove: {
          title: 'Easy there!',
          text: 'Do you really want remove this record?',
        },
        remove_all: {
          title: 'Easy there!',
          text: 'Do you really want remove all records on this database?',
        },
      },
    },

    importer: {
      title: 'Data importer',
      actions: {
        download_template: 'Download CSV template',
      },
    },

    exporter: {
      title: 'Data exporter',
      actions: {
        download_csv: 'Download CSV',
        show_downloads: 'Show downloads',
      },
      types: {
        work_objects: 'Work Objects',
        bot_reports: "Bot's Reports",
        databases: 'Databases',
      },
    },

    admin: {
      members: {
        tab: 'Members',
      },
      roles: {
        tab: 'Roles',
        columns: {
          name: 'Name',
        },
        form: {
          name_input: {
            label: 'Name:',
            placeholder: "Type role's name",
          },

          sections: {
            permissions: {
              title: 'Permissions',
            },
          },
        },
      },

      invites: {
        tab: 'Invites',
        title: 'Invite Member',
        messages: {
          invite_sent: 'Invite sent',
          invite_conflit: 'There is a invite for this email already',
        },
        columns: {
          invited_by: 'Invited by',
          date: 'Date',
        },

        form: {
          email_input: {
            label: 'Type the new member email:',
          },
          role_input: {
            label: 'Select the new member role:',
          },
        },
      },

      categories: {
        tab: 'Departments',
        errors: {
          remove: "Department can't to be removed. Please, make sure there is not bot associated to it.",
        },
        form: {
          name_input: {
            placeholder: 'Type the new department name',
          },
        },
      },
    },

    components: {
      users: {
        role_select: {
          placeholder: 'Add roles',
        },
        actions: {
          remove: 'Remove member',
          make_admin: 'Make admin',
          remove_admin: 'Remove admin',
        },
        confirmations: {
          remove: `Do you really want to remove the member <b>{{name}}</b> from the team?`,
          make_admin: 'Do you really want to make the member <b>{{name}}</b> company admin?',
          remove_admin: 'Do you really want to remove the member <b>{{name}}</b> privileges as company admin?',
        },
      },
    },

    react_query_builder: {
      larger: '	Greater than',
      smaller: 'Less than',
      larger_equal: 'Greater than or equal to',
      smaller_equal: 'Less than or equal to',
      equal: 'Equal to',
      not_equal: 'Not equal',
      not_in: 'Not in',
      between: 'Between',
      not_between: 'Not between',
      like: 'Contains',
      not_like: 'Not contains',
      select_value: 'Select your value',
    },

    pagination: {
      items_per_page: 'Quantity of items per page',
    },
  },
};
